module.exports = __webpack_public_path__ + "static/media/breadcrumb-icon.9e546014.svg";